import './imagetextblock.less'

import {m, Picture, View} from '@codeurs/front'
import {FunctionComponent} from 'react'
import {ImageType, LinkType} from 'types'
import {style} from 'util/style'
import {ImageLoader, isGif} from 'views/partials/imageloader'
import {Theme} from 'views/theme'
import {Block} from './blocks'
import {ImageUseLink} from './imageblock'

export type ImageTextBlockType = {
	image: ImageType
	image_position: 'left' | 'right'
	text: string
	image_description?: string
	image_link: LinkType
	image_width?: string
	image_height?: string
	image_center?: boolean
	blue_bg?: boolean
}

const styles = style('imagetextblock')

export const ImageTextBlock: FunctionComponent<ImageTextBlockType> = ({
	text,
	blue_bg,
	...rest
}) => {
	const {
		image,
		image_center,
		image_description,
		image_position,
		image_width,
		image_height
	} = rest
	const asGif = isGif(image)
	return (
		<Block
			class={styles.mod([`image-${image_position}`, blue_bg && 'blue_bg'])}
		>
			<div
				class={styles('col')
					.mod({center: image_center})
					.with('imagetextblock-col-image')}
			>
				<ImageUseLink imagetextblock={true} {...rest}>
					<ImageLoader
						image={image}
						image_width={image_width}
						textblock={true}
						gif={asGif}
					/>
				</ImageUseLink>
				{image_description && (
					<div class={styles('col-image-description')}>
						<Theme.Wysiwyg>{image_description}</Theme.Wysiwyg>
					</div>
				)}
			</div>
			<div class={styles('col').with('imagetextblock-col-text')}>
				<Theme.Wysiwyg>{text}</Theme.Wysiwyg>
			</div>
		</Block>
	)
}
